module.exports = __webpack_public_path__ + "static/img/户外拓展@2x (1).66d76e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/户外拓展@2x (1).png
// module id = TOYJ
// module chunks = 1